/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_GoogleInputs */

const en_signin_google = /** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Google`)
};

const id_signin_google = /** @type {(inputs: Signin_GoogleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanjut dengan Google`)
};

/**
* | output |
* | --- |
* | "Continue with Google" |
*
* @param {Signin_GoogleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_google = /** @type {((inputs?: Signin_GoogleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_GoogleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_google(inputs)
	return en_signin_google(inputs)
});